import styled from 'foundations-theming/utils';
import { useContext } from 'react';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { Flex } from '../../../../components/Flex/Flex';
// import { Theme } from 'foundations-theming';
import { filterProps } from '../../../../utils/filterProps';
import { useIsDisplayOptimized } from '../../../context/DisplayOptimizedContext';
import { VENUS_LAYER } from '../../../constants';
import { useInputGroupContext } from '../../../components/InputGroup/InputGroupProvider';
import { PADDING } from '../../../../constants/nonTokenisedValues';
import { MicroDateInputContext } from '../../MicroDateInput/MicroDateInputContext';
import { MicroTimeInputContext } from '../../MicroTimeInput/MicroTimeInputContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InputWrapper = styled.div.withConfig({
  displayName: "InputIconWrapper__InputWrapper",
  componentId: "sc-1e6zbay-0"
})(({
  size,
  theme,
  $cssStyles,
  $isDisplayOptimized,
  $isMicroDateInput,
  $isMicroTimeInput
}) => {
  return Object.assign({
    position: 'relative',
    '&& input': {
      paddingLeft: $isDisplayOptimized ? theme.space['500'] : $isMicroDateInput || $isMicroTimeInput ? `calc(${PADDING.MICRO_DATE_TIME_INPUT_ICON_PADDING_LEFT} + ${size || 0}px)` : `calc(${PADDING.DATE_TIME_ICON_PADDING_LEFT} + ${size || 0}px)` // Provide a fallback if size is undefined
    }
  }, $cssStyles);
});
export const InputIconWrapper = props => {
  const {
    domProps
  } = filterProps(props);
  const isDisplayOptimized = useIsDisplayOptimized();
  // const theme = useTheme();
  const inputGroupContext = useInputGroupContext();
  const isInInputGroup = !!inputGroupContext;
  const microDateInputContext = useContext(MicroDateInputContext);
  const microTimeInputContext = useContext(MicroTimeInputContext);
  const isMicroDateInput = !!microDateInputContext;
  const isMicroTimeInput = !!microTimeInputContext;
  const {
    children,
    size,
    icon: Icon,
    disabled,
    $cssStyles,
    isMicroDateInput: propIsMicroDateInput,
    isMicroTimeInput: propIsMicroTimeInput,
    onFocus
  } = props;
  const iconPixelSize = useIconSize(size) || '16px';
  const computedNumberSize = parseInt(iconPixelSize.replace('px', ''), 10);

  // Use the prop if provided, otherwise check the context
  const finalIsMicroDateInput = propIsMicroDateInput !== null && propIsMicroDateInput !== void 0 ? propIsMicroDateInput : isMicroDateInput;
  const finalIsMicroTimeInput = propIsMicroTimeInput !== null && propIsMicroTimeInput !== void 0 ? propIsMicroTimeInput : isMicroTimeInput;
  return /*#__PURE__*/_jsxs(InputWrapper, Object.assign({}, domProps, {
    $cssStyles: $cssStyles,
    $isDisplayOptimized: isDisplayOptimized,
    $isMicroDateInput: finalIsMicroDateInput,
    $isMicroTimeInput: finalIsMicroTimeInput,
    size: computedNumberSize,
    onFocus: onFocus,
    children: [children, /*#__PURE__*/_jsx(Flex, {
      position: "absolute",
      insetBlockEnd: "0",
      insetBlockStart: "0",
      insetInlineStart: "0",
      paddingInline: isDisplayOptimized ? '0' : finalIsMicroDateInput || finalIsMicroTimeInput ? '200' : '400',
      alignItems: "center",
      zIndex: isInInputGroup ? VENUS_LAYER : undefined,
      pointerEvents: "none",
      children: /*#__PURE__*/_jsx(Icon, {
        color: disabled ? 'text-core-disabled' : 'inherit',
        size: size
      })
    })]
  }));
};